import { render, staticRenderFns } from "./TabularImport.vue?vue&type=template&id=5681d50e"
import script from "./TabularImport.vue?vue&type=script&lang=js"
export * from "./TabularImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports